module.exports = __webpack_public_path__ + "img/icon-trash.58c8d77a.svg";